import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

function toStr(v) {
  if (v === undefined || v === null) return "";
  return String(v).trim();
}

export default function SimpleTableWithFooter({ columns, rows, footer, emptyText = "No data" }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const cellSx = {
    whiteSpace: "nowrap",
    px: isMobile ? 1 : 2,
    py: isMobile ? 0.5 : 1,
    fontSize: isMobile ? 12 : 14,
  };
  const headFootSx = { ...cellSx, fontWeight: 600 };

  return (
    <div>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "100%",
          overflowX: "auto",
          overflowY: "auto",
          maxHeight: 520,
          border: 1,
          borderColor: "divider",
          borderRadius: 2,
          WebkitOverflowScrolling: "touch",
        }}
      >
        <Table stickyHeader size="small" sx={{ minWidth: isMobile ? undefined : 800 }}>
          <TableHead>
            <TableRow>
              {columns.map((c) => (
                <TableCell key={c.key} sx={headFootSx}>
                  {c.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length}>
                  <Typography variant="body2" color="text.secondary">
                    {emptyText}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((r, idx) => (
                <TableRow key={r.__id ?? idx} hover>
                  {columns.map((c) => (
                    <TableCell key={c.key} sx={cellSx}>
                      {c.render ? c.render(r) : toStr(r[c.key])}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
          {footer && (
            <TableFooter>
              <TableRow>
                {columns.map((c) => (
                  <TableCell key={c.key} sx={headFootSx}>
                    {footer[c.key] ?? ""}
                  </TableCell>
                ))}
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </TableContainer>
      {isMobile && columns.length > 4 && rows.length > 0 && (
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
          Swipe the table sideways to see more columns →
        </Typography>
      )}
    </div>
  );
}
